import { HttpParams } from '@angular/common/http';

export class commonClass {
  public static VERSIONNUMBER: string = '1.97';
  public static LASTDEPLOYTIME: number = 1782378042442;
  public static Month: string[] = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  public static DISABLE_MESSAGE: number = 0;
  public static ENABLE_MESSAGE: number = 1;
  public static CONGRESS_ID: number = 1;
  public static DELETE_MESSAGE: number = 3;
  public static GENERAL_INFORMATION: number = 82;
  public static DTC_MATERIAL: number = 83;
  public static SESSION_INFO: number = 84;
  public static PHYSICIAN_ADS_HANDOUTS: number = 85;
  public static TRIALS_PUBLICATIONS: number = 86;
  public static EXHIBITS: number = 87;
  public static POSTERS_ABSTRACTS: number = 88;
  public static KOL_DOCTORNOTES: number = 89;
  public static KITS_KIQS: number = 90;
  public static OTHER: number = 91;
  public static CONGRESS_REPORT: number = 92;
  public static OTHER_REPORTS: number = 93;
  public static UPCOMING_EVENTS: number = 94;
  public static NEWS: number = 95;
  public static CLINICAL_TRIAL: number = 96;
  public static PRODUCT_PROFILE: number = 97;
  public static PRODUCT_DETAILS: number = 98;
  public static DOCUMENT_TYPE_NEWS_LETTERS: number = 99;
  public static WORKSHOP: number = 100;
  public static WORKSHOP_DETAIL: number = 101;
  public static SESSION_NOTES: number = 102;
  public static SESSION_PICTURES: number = 103;
  public static Resource_Request: number = 104;
  public static TIMELINE_TYPE_ASC: string = 'asc';
  public static TIMELINE_TYPE_DSC: string = 'dsc';
  public static likeFav: number = 1;
  public static unlikeUnfav: number = 2;
   public static DOCUMENT_TYPE_ECHO: string = '84,89,95';
  public static EDITORTOOLS: object = {
    type: 'MultiRow',
    items: [
      'Undo',
      'Redo',
      '|',
      'Bold',
      'Italic',
      'Underline',
      'StrikeThrough',
      '|',
      'FontName',
      'FontSize',
      'FontColor',
      'BackgroundColor',
      '|',
      'SubScript',
      'SuperScript',
      '|',
      'LowerCase',
      'UpperCase',
      '|',
      'Formats',
      'Alignments',
      '|',
      'OrderedList',
      'UnorderedList',
      '|',
      'Indent',
      'Outdent',
      '|',
      'CreateLink',
      'Image',
      '|',
      'ClearFormat',
      'Print',
      'SourceCode',
      '|',
      'FullScreen',
    ],
  };

  public static validForQuestion: Array<string> = [
    'docx',
    'doc',
    'pptx',
    'ppt',
    'pdf',
    'txt',
    'json',
  ];
  public static allImages: Array<string> = [
    'png',
    'jpg',
    'jpeg',
    'gif',
    'tiff',
    'bpg',
    'webp',
    'heic',
    'svg',
  ];

  public static allAudio: Array<string> = [
  'mp3',
  'wav',
  'aac',
  'ogg',
  'flac',
  'm4a',
  'wma',
  'aiff',
  'opus',
  'amr',
  'webm'
];

  public static securityEnum: Array<{ id: string; data: string }> = [
    { id: '0', data: 'OPEN' },
    { id: '1', data: 'LOW' },
    { id: '2', data: 'MEDIUM' },
    { id: '3', data: 'HIGH' },
  ];
  public static securityEnum1: any[] = [
    { id: '0', data: 'OPEN' },
    { id: '1', data: 'LOW' },
    { id: '2', data: 'MEDIUM' },
    { id: '3', data: 'HIGH' },
  ];

  public static sortLikes: string = 'likes';
  public static sortFavourites: string = 'favourites';
  public static sortComment: string = 'comment';
  public static sortAuthor: string = 'author';
  public static sortCompany: string = 'company';
  public static sortBrand: string = 'brand';
  public static sortIndication: string = 'indication';
  public static sortLatest: string = 'latest';
  public static sortCategory: string = 'category';
  public static sortEnum: Object[] = [
    { value: commonClass.sortLatest, title: 'Latest' },
    { value: commonClass.sortLikes, title: 'Likes' },
    { value: commonClass.sortFavourites, title: 'Favourites' },
    { value: commonClass.sortCategory, title: 'Category' },
    { value: commonClass.sortComment, title: 'Comment' },
    { value: commonClass.sortAuthor, title: 'Author' },
    { value: commonClass.sortCompany, title: 'Company' },
    { value: commonClass.sortBrand, title: 'Brand' },
    { value: commonClass.sortIndication, title: 'Indication' },
  ];
  public static sortInAPIComment: string = 'latest_comment';
  public static sortInAPIAttach: string = 'latest_attach';

  public static eventtypeUpComing: string = 'upcoming';
  public static eventtypePast: string = 'past';

  public static BrandSuccess: string = 'Product Added Successfully.';
  public static CompanySuccess: string = 'Company Added Successfully.';

  public static SelectDoc: string = 'Please select at least one document';
  public static SelectCategory: string = 'Please select Category';
  public static EnterName: string = 'Please enter Name';
  public static EnterEmail: string = 'Please enter Email';
  public static EnterValidEmail: string = 'Please enter valid Email';
  public static EnterPwd: string = 'Please enter Password';
  public static EnterRoll: string = 'Please select Role';
  public static EnterSecurity: string = 'Please select Security';
  public static EnterExpiry: string = 'Please select Expiry date';
  public static EnterFrenchise: string = 'Please select Frenchise';
  public static EnterGroup: string = 'Please enter Group';
  public static EnterNotes: string = 'Please enter Notes';
  public static EnterLink: string = 'Please enter Link';
  public static EnterDate: string = 'Please enter Datetime';
  public static EnterStartDate: string = 'Please enter StartDate';
  public static EnterEndDate: string = 'Please enter EndDate';
  public static EnterLocation: string = 'Please enter Place';
  public static EnterZone: string = 'Please enter Timezone';
  public static EnterClinicalTrial: string = 'Please enter Clinical Trial name';
  public static EnterPhase: string = 'Please select Phase';
  public static EnterCountry: string = 'Please select Country';
  public static EnterProduct: string = 'Please select Product';
  public static EnterTitle: string = 'Please enter Title';
  public static EnterLinkV: string = 'Please enter valid Link';
  public static EnterCongress: string = 'Please select Congress';

  public static COMMENT_TYPE_TEXT: string = 'text';
  public static COMMENT_TYPE_IMAGE: string = 'image';
  public static COMMENT_TYPE_POLL: string = 'poll';
  public static COMMENT_TYPE_ANSWER: string = 'answer';

  //mcq - Type of Selection
  public static TYPE_POLL_FREE_TEXT: number = 0;
  public static TYPE_POLL_SINGLE: number = 1;
  public static TYPE_POLL_MULTIPLE: number = 2;

  public static TYPE_POLL_ANSWER_DEFAULT: string = '0';
  public static TYPE_POLL_ANSWER_SELECTED: string = '1';

  public static PollResultsShare: number = 1;
  public static PollResultsPrivate: number = 0;

  public static DeleteStateId: number = 4;
  public static DraftStateId: number = 3;
  public static ActiveStateId: number = 2;
  public static InactiveStateId: number = 1;

  public static detailCallerComponentFromEdit: string = 'edit';
  public static detailCallerComponentDashboard: string = 'dashboard';
  public static detailCallerComponentWorkshop: string = 'workshop';
  public static detailCallerComponentClinicalTrials: string = 'clinicaltrails';
  public static detailCallerComponentNewsletter: string = 'newsletter';
  public static detailCallerComponentProductProfile: string = 'productprofile';
  public static detailCallerComponentNotification: string = 'notification';

  //User Roles Constant
  public static RoleUserView: string = '0';
  public static RoleEditorView: string = '1';
  public static RolePowerUserView: string = '3';
  public static RoleContentManagerView: string = '4';
  public static RoleSuperUserView: string = '5';

  //preference
  public static chartPreference: string = 'chart';
  public static listPreference: string = 'list';
  public static htmlPreference: string = 'html';

  //Colorcodes
  public static TimelineIndicationColorCodes: string[] = [
    '#6B1D86',
    '#27056B',
    '#5E17EB',
    '#004AAD',
    '#441A00',
    '#A60000',
    '#A63F00',
    '#FF5757',
    '#033418',
    '#008037',
  ];
  public static ApexchartColorCodes: string[] = [
    '#008ffb',
    '#00e396',
    '#feb019',
    '#ff4560',
    '#b6d05d',
    '#d05d9f',
    '#60ff45',
    '#eef282',
    '#dcb4b4',
    '#f5ff45',
  ];

  public static noNotificationMessage: string =
    'Stay updated by allowing notifications. Right now notifications are either not supported or disabled on your browser. Please change your browser or enable notification from your browser settings.';
  public static noImage = '../../assets/images/NoImageDash.png';

  public static apiSearchDetailScreenMessage: string =
    '[doc] attachment (s) selected please give me a moment to analyze everything then you can ask your questions';
  public static apiSearchMessage: string =
    '[doc] document (s) selected please give me a moment to analyze everything then you can ask your questions';
  public static chatReadyMessage: string =
    'Ok I’m ready ask me anything related to the documents you selected.';

  public static chatbotStartApi: string = 'api_multiple_v10.php';
  //public static chatbotStartApi: string = "api_multiple.php";
  //public static chatbotStartApi: string = "ollama_v1.php";
  public static chatbotMessageApi: string = 'api_multiple_v9.php';
  //public static chatbotMessageApi: string = "apiv2.php";
  //public static chatbotMessageApi: string = "ollama_v2.php";

  public static chatbotListApi: string = 'chatbot_list.php';
  public static chatbotDetailApi: string = 'chatbot_detail.php';

  public static vectorSearchApi: string = 'Vector_search.php';

  //Setting of MultiSelection
  public static roaMultiSelectSetting: {} = {
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: '',
    primaryKey: 'DELIVEYID',
    labelKey: 'DELIVERY',
    noDataLabel: 'Search...',
    enableSearchFilter: true,
    searchBy: ['DELIVERY'],
    position: 'top',
    tagToBody: false,
    escapeToClose: false,
  };
  public static commonMultiSelectSetting: {} = {
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: 'myclass custom-class',
    primaryKey: 'id',
    labelKey: 'itemName',
    noDataLabel: 'Search...',
    enableSearchFilter: true,
    searchBy: ['itemName'],
    autoPosition: false,
    tagToBody: false,
    escapeToClose: false,
  };
  public static clinicalMultiSelectSetting: {} = {
    text: 'Select',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    classes: 'myclass custom-class',
    primaryKey: 'id',
    labelKey: 'itemName',
    noDataLabel: 'Search...',
    enableSearchFilter: true,
    searchBy: ['itemName'],
    position: 'bottom',
  };

  //pattern
  public static weburlPattern: string =
    '^(http(s)://.)[-a-zA-Z0-9@:%._+~#=]{2,256}.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$';

  public static PHASE_BUTTON: Array<Object> = [
    { name: 'Approved/Marked', key: true, value: 'approved', id: '920' },
    {
      name: 'Pre Registration',
      key: false,
      value: 'preregistration',
      id: '932',
    },
    { name: 'Phase III', key: false, value: 'phase_iii', id: '923' },
    { name: 'Phase II', key: false, value: 'phase_ii', id: '922' },
    { name: 'Phase I', key: false, value: 'phase_i', id: '921' },
    { name: 'Pre-Clinical', key: false, value: 'pre_clinic', id: '924' },
    { name: 'Planned', key: false, value: 'planned', id: '925' },
  ];

  public static PRIORITY_BUTTON: Array<Object> = [
    { name: 'High', key: false },
    { name: 'Medium', key: false },
    { name: 'Low', key: false },
  ];

  public static STATUS_BUTTON: Array<Object> = [
    { name: 'Active', key: true, id: commonClass.ActiveStateId },
    { name: 'Inactive', key: false, id: commonClass.InactiveStateId },
    { name: 'Archive', key: false, id: commonClass.DeleteStateId },
  ];
  public static galleryTerm: string = 'Gallery';
  public static reportTerm: string = 'Reports';
  public static newsTerm: string = 'News';
  public static ppTerm: string = 'Product Profiles';
  public static ctTerm: string = 'Clinical Trials';
  public static eventTerm: string = 'Upcoming Events';
  public static kitsTerm: string = 'KITS/KIQS';
  public static peventTerm: string = 'Past Events';

  public static Dashboard2DefaultButtonList: Array<Object> = [
    { name: commonClass.galleryTerm, key: true, visible: true },
    { name: commonClass.reportTerm, key: true, visible: true },
    { name: commonClass.newsTerm, key: true, visible: true },
    { name: commonClass.eventTerm, key: true, visible: true },
    { name: commonClass.kitsTerm, key: false, visible: true },
    { name: commonClass.peventTerm, key: false, visible: true },
    { name: commonClass.ppTerm, key: false, visible: true },
    { name: commonClass.ctTerm, key: false, visible: true },
  ];
  public static Dashboard3DefaultButtonList: Array<Object> = [
    { name: commonClass.ppTerm, key: true, visible: true },
    { name: commonClass.ctTerm, key: true, visible: true },
    { name: commonClass.newsTerm, key: true, visible: true },
    { name: commonClass.eventTerm, key: false, visible: true },
    { name: commonClass.peventTerm, key: true, visible: true },
    { name: commonClass.reportTerm, key: false, visible: true },
    { name: commonClass.galleryTerm, key: false, visible: true },
    { name: commonClass.kitsTerm, key: false, visible: true },
  ];

  public static atAGlanceButtonList: Array<Object> = [
    { name: 'Products / Trials', key: true, visible: true },
    { name: 'Events', key: true, visible: true },
    { name: 'News', key: true, visible: true },
    { name: 'Recent', key: true, visible: true },
  ];

  public static AccountOtherFeaturesList: Array<Object> = [
    {
      optionKey: 'capture',
      optionSelected: false,
      optionValue: 'View Capture',
      key: '1',
    },
    {
      optionKey: 'events',
      optionSelected: false,
      optionValue: 'View Upcoming Event',
      key: '3',
    },
    {
      optionKey: 'gallery',
      optionSelected: false,
      optionValue: 'View Gallery',
      key: '2',
    },
    {
      optionKey: 'news',
      optionSelected: false,
      optionValue: 'View News',
      key: '4',
    },
    {
      optionKey: 'reports',
      optionSelected: false,
      optionValue: 'View Report',
      key: '5',
    },
    {
      optionKey: 'vchat',
      optionSelected: false,
      optionValue: 'View Chat',
    },
    {
      optionKey: 'congress',
      optionSelected: false,
      optionValue: 'View Congress',
      key: '6',
    },
    {
      optionKey: 'kits',
      optionSelected: false,
      optionValue: 'View Kits\\Kiqs',
      key: '7',
    },
    {
      optionKey: 'chat',
      optionSelected: false,
      optionValue: 'Contribute Chat',
    },
    {
      optionKey: 'export',
      optionSelected: false,
      optionValue: 'Export',
    },
    {
      optionKey: 'dm',
      optionSelected: false,
      optionValue: 'Direct Message',
    },
    {
      optionKey: 'congress_admin',
      optionSelected: false,
      optionValue: 'Congress Admin',
    },
    {
      optionKey: 'clinical_trials',
      optionSelected: false,
      optionValue: 'Clinical Trials',
      key: '8',
    },
    {
      optionKey: 'product',
      optionSelected: false,
      optionValue: 'Product Profiles',
      key: '9',
    },
    {
      optionKey: 'timelines',
      optionSelected: false,
      optionValue: 'Timelines',
      key: '10',
    },
    {
      optionKey: 'newsletter',
      optionSelected: false,
      optionValue: 'NewsFlash',
      key: '11',
    },
    {
      optionKey: 'workshop',
      optionSelected: false,
      optionValue: 'Workshop',
      key: '12',
    },
    {
      optionKey: 'ataglance',
      optionSelected: false,
      optionValue: 'At a Glance',
      key: '13',
    },
    {
      optionKey: 'research',
      optionSelected: false,
      optionValue: 'Research Request',
    },
     {
      optionKey: 'echo',
      optionSelected: false,
      optionValue: 'Echo',
    },
     {
      optionKey: 'medadvisory',
      optionSelected: false,
      optionValue: 'MedAdvisory',
    },
     {
      optionKey: 'navigator',
      optionSelected: false,
      optionValue: 'Navigator',
    },
     {
      optionKey: 'navigator_admin',
      optionSelected: false,
      optionValue: 'Navigator Admin',
    },
    //,
    //{
    //  "optionKey": "dashboard",
    //  "optionSelected": false,
    //  "optionValue": "Dashboard",
    //  "key": "0"
    //}
  ];
  public static AccountRoleList: Array<Object> = [
    {
      RoleTitle: 'User',
      RoleValue: '0',
      RoleColor: '#1EA7FF',
    },
    {
      RoleTitle: 'Editor',
      RoleValue: '1',
      RoleColor: '#0ACF83',
    },
    {
      RoleTitle: 'Power User',
      RoleValue: '3',
      RoleColor: '#5051F9',
    },
    {
      RoleTitle: 'Content Manager',
      RoleValue: '4',
      RoleColor: '#FE7F2E',
    },
    {
      RoleTitle: 'Super User',
      RoleValue: '5',
      RoleColor: '#F95050',
    },
    {
      RoleTitle: 'Deactivated',
      RoleValue: '101',
      RoleColor: '#545454',
    },
  ];

  public static buttonListonpopup: Array<Object> = [
    { name: 'Users', key: true, value: 'users' },
    { name: 'Groups', key: false, value: 'groups' },
    { name: 'Congress', key: false, value: 'congressreport' },
  ];

  public static getUserRole(id) {
    var RoleList = this.AccountRoleList.filter((x) => x['RoleValue'] == id);
    if (RoleList.length > 0)
      return this.AccountRoleList.filter((x) => x['RoleValue'] == id)['0'][
        'RoleTitle'
      ];
    else return 'Suspecious';
  }
  public static getUserRoleColor(id) {
    var RoleList = this.AccountRoleList.filter((x) => x['RoleValue'] == id);
    if (RoleList.length > 0)
      return this.AccountRoleList.filter((x) => x['RoleValue'] == id)['0'][
        'RoleColor'
      ];
    else return '#346D11';
  }

  public static getSecurityLevel(id) {
    if (this.securityEnum.filter((x) => x['id'] == id).length > 0)
      return this.securityEnum.filter((x) => x['id'] == id)['0']['data'];
    else return '';
  }
  public static ChangePasswordDataRequest(uid, pwd) {
    return new HttpParams().set('userid', uid).set('pwd', pwd);
  }

  public static ChechNotificationRequest(userid, subprojectid) {
    return new HttpParams()
      .set('poll', 1)
      .set('userid', userid)
      .set('subprojectid', subprojectid);
  }
  public static GallaryDataRequest(start, uid, subprojectid, sort) {
    return new HttpParams()
      .set('userid', uid)
      .set('subprojectid', subprojectid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('first', start)
      .set('last', 5)
      .set('sort', sort)
      .set('stateid', 2);
  }
  public static ReportDataRequest(start, uid, subprojectid, sort) {
    return (
      new HttpParams()
        .set('userid', uid)
        .set('subprojectid', subprojectid)
        .set('timestamp', 0)
        .set('securelvl', 3)
        .set('first', start)
        .set('last', 5)
        .set('doctypeid', this.CONGRESS_REPORT)
        //.set('doctypeid', this.OTHER_REPORTS + ',' + this.CONGRESS_REPORT)
        .set('sort', sort)
        .set('stateid', 2)
    );
  }
  public static NewsDataRequest(start, uid, subprojectid, sort) {
    return new HttpParams()
      .set('userid', uid)
      .set('subprojectid', subprojectid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('first', start)
      .set('last', 5)
      .set('doctypeid', this.NEWS)
      .set('sort', sort)
      .set('stateid', 2);
  }
  public static UpcomingEventDataRequest(start, uid, subprojectid, sort) {
    return new HttpParams()
      .set('userid', uid)
      .set('subprojectid', subprojectid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('first', start)
      .set('last', 5)
      .set('doctypeid', this.UPCOMING_EVENTS)
      .set('eventtype', this.eventtypeUpComing)
      .set('sort', sort)
      .set('stateid', 2);
  }
  public static PastEventDataRequest(start, uid, subprojectid, sort) {
    return new HttpParams()
      .set('userid', uid)
      .set('subprojectid', subprojectid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('first', start)
      .set('last', 5)
      .set('doctypeid', this.UPCOMING_EVENTS)
      .set('eventtype', this.eventtypePast)
      .set('sort', sort)
      .set('stateid', 2);
  }
  public static KitsDataRequest(start, uid, subprojectid, sort) {
    return new HttpParams()
      .set('userid', uid)
      .set('subprojectid', subprojectid)
      .set('timestamp', 0)
      .set('securelvl', 3)
      .set('first', start)
      .set('last', 5)
      .set('doctypeid', this.KITS_KIQS)
      .set('sort', sort)
      .set('stateid', 2);
  }
  public static getFileType(type) {
    let typeC = type.split('.').pop().toLowerCase();
    switch (typeC) {
      case 'png':
        return 'image/jpeg';
      case 'jpeg':
        return 'image/jpg';
      case 'jpg':
        return 'image/jpeg';
      case 'gif':
        return 'gif';
      case 'tiff':
        return 'tiff';
      case 'bpg':
        return 'image/bpg';
      case 'txt':
        return 'text/plain';
      case 'm4a':
        return 'audio/mp4';
      default:
        return 'application/pdf';
    }
  }
  public static isEmail(search: string) {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      search
    );
  }
  public static getColor(term) {
    switch (term) {
      case null:
        return 'white';
      case '3': // low
        return 'green';
      case '1': // hight
        return 'red';
      case '2': // medium
        return 'yellow';
      default:
        return 'black';
    }
  }

  public static createDetailScreenUrl(doctypeide, documentid) {
    return '/dashboard/detail?dt=' + doctypeide + '&doc=' + documentid;
  }
  public static isNull(str) {
    if (
      str &&
      str != null &&
      str != '' &&
      str.toString().trim() != '' &&
      str != 'null'
    ) {
      return false;
    } else {
      return true;
    }
  }

  public static getSubArray(arr, start, end) {
    return arr.slice(start, end);
  }
  public static getGeneric(item) {
    if (item['GENERIC']) {
      if (commonClass.isNull(item['GENERIC']) == false) {
        return '(' + item['GENERIC'] + ')';
      } else {
        return '';
      }
    }
    return '';
  }
  public static getThisPageName(URL: string) {
    let currentURL = URL.split('/');
    if (currentURL[2].toString().startsWith('detail', 0)) {
      currentURL[2] = 'detail';
    }
    return currentURL[2];
  }
  public static getThisPageName3(URL: string) {
    let currentURL = URL.split('/');
    return currentURL[3];
  }

  public static FILE_GROUPS: { [key: string]: string[] } = {
    document: ['.docx', '.doc', '.txt', '.rtf'],
    spreadsheet: ['.xlsx', '.xls', '.csv'],
    presentation: ['.pptx', '.ppt'],
    image: ['.jpg', '.jpeg', '.png', '.gif', '.svg'],
    media: ['.mp3', '.wav', '.mp4', '.mov', '.avi'],
    archive: ['.zip', '.rar', '.7z', '.exe', '.app'],
    pdf: ['.pdf'],
  };

  public static getFileTypeByFilename(filename: string): string {
    const lastDotIndex = filename.lastIndexOf('.');
    if (lastDotIndex < 1) {
      return 'document';
    }

    const extension = filename.substring(lastDotIndex).toLowerCase();
    for (const category in commonClass.FILE_GROUPS) {
      if (commonClass.FILE_GROUPS[category].includes(extension)) {
        return category;
      }
    }

    return 'document';
  }
}
export class congressColorSchema {
  public static meetTHeProf = '#0E4189';
  public static symposium = '#00792A';
  public static oralsession = '#746106';
  public static default = '#0E4189';
  public static postersession = '#0083A4';
}
export class CaptureBase {
  CATEGORY: Category[];
  GROUP: Group[];
  BRAND: Brand[];
  INDICATION: Indication[];
  COMPANY: Company[];
  PHASE: Phase[];
  PRIORITY: Priority[];
  REPORTS: Report[];
  CONGRESS: any[];
  COUNTRY: Country[];
  TRIALSTATUS: Trialstatus[];
  CLINICALTRIALS: ClinicalTrial[];
  MOA: Moa[];
  CLASS: classs[];
}

export class EchoCaptureBase {
  CATEGORY: Category[];
  GROUP: Group[];
  BRAND: Brand[];
  INDICATION: Indication[];
  COMPANY: Company[];
  PHASE: Phase[];
  PRIORITY: Priority[];
  REPORTS: Report[];
  CONGRESS: any[];
  COUNTRY: Country[];
  TRIALSTATUS: Trialstatus[];
  CLINICALTRIALS: ClinicalTrial[];
  MOA: Moa[];
  CLASS: classs[];
  RECORD_CATEGORY: RecordCategory[];
  SOURCE_INSTRUCTION: SourceInstruction[];
}
export class CaptureAddModel {
  userid: string;
  subprojectid: string;
  doctypeid: number; //CategoryID
  documentid: string;
  groupid: number = 0;
  priorityid: number = 0;
  title: string;
  notes: string = '';
  phaseid: number = 0;
  securelvl: string = '0';
  acronymsid: number = 0;
  notify: number; //0-> without notification , 1 with notification
  brandid: BrandRequestModel[];
  indicationid: IndicationRequestModel[];
  sponsorid: CompanyRequestModel[];
  keywords: string;
  acronyms: string;
  trialstatusid: number = 0;
  targetn: string;
  currentn: string;
  countryid: number = 0;
  congressid: number = 0;
  zoneid: number = 0;
  link: string;
  date: string;
  location: string;
  startdate: string;
  enddate: string;
  launchdate: string | Date;
  lassumption: string;
  //Extra
  DOCTYPENAME: string;
}

export class EchoCaptureAddModel {
  userid: string;
  subprojectid: string;
  doctypeid: number; //CategoryID
  documentid: string;
  groupid: number = 0;
  priorityid: number = 0;
  title: string;
  notes: string = '';
  phaseid: number = 0;
  securelvl: string = '0';
  acronymsid: number = 0;
  notify: number;
  brandid: BrandRequestModel[];
  indicationid: IndicationRequestModel[];
  sponsorid: CompanyRequestModel[];
  keywords: string;
  acronyms: string;
  trialstatusid: number = 0;
  targetn: string;
  currentn: string;
  countryid: number = 0;
  congressid: number = 0;
  zoneid: number = 0;
  link: string;
  // date: string;
  // location: string;
  // startdate: string;
  // enddate: string;
  // launchdate: string | Date;
  lassumption: string;
  NAME: string;
}

export class BrandRequestModel {
  brandid: number;
  primary: number;
}
export class Brand {
  BRANDID: string;
  BRANDNAME: string;
  SUBPROJECTID: string;
  //extra
  primary: number = 0;
  checked: boolean = false;
}

export class Category {
  DOCTYPEID: string;
  CATEGORYID: string;
  DOCTYPENAME: string;
  DOCTYPEABBREV: string;
}

export class RecordCategory {
  COLOUR: string;
  DOCTYPEID: string;
  HASHTAGS: string;
  ID: string;
  NAME: string;
  SOURCE_ID: string;
  S_NAME: string;

}

export class SourceInstruction {
  COLOUR: string;
  DOCTYPEID: string;
  DOCTYPENAME: string | null;
  HASHTAGS: string;
  ID: string;
  INSTRUCTION: string;
  INSTRUCTIONID: string;
  NAME: string;
  PROMPT: string;
  PROMPTID: string;
  SOURCE_ID: string;
  SUBPROJECTID: string;
  S_NAME: string;
}

export class ClinicalTrial {
  ACRONYMSID: string;
  ACRONYMS: string;
}

export class Company {
  SPONSORID: string;
  SPONSORNAME: string;
  SUBPROJECTID: string;
  //extra
  primary: number = 0;
  checked: boolean = false;
}
export class CompanyRequestModel {
  sponsorid: number;
  primary: number;
}
export class Country {
  COUNTRYID: string;
  COUNTRYNAME: string;
}

export class Group {
  PRIMARY: string;
  GROUPID: string;
  GROUPNAME: string;
}

export class IndicationRequestModel {
  indicationid: number;
  primary: number;
}
export class Indication {
  INDICATIONID: string;
  INDICATIONNAME: string;
  SUBPROJECTID: string;
  //extra
  primary: number = 0;
  checked: boolean = false;
}

export class Moa {
  MOAID: string;
  MOANAME: string;
  MOAABBREV: string;
  SUBPROJECTID: string;
}
export class classs {
  CLASSID: string;
  CLASSNAME: string;
  SUBPROJECTID: string;
}

export class Phase {
  PHASEID: string;
  PHASENAME: string;
  SUBPROJECTID: string;
}

export class Priority {
  PRIORITYID: string;
  PRIORITYNAME: string;
}

export class Report {
  DOCTYPEID: string;
  DOCTYPENAME: string;
}
export class Trialstatus {
  TRIALSTATUSID: string;
  TRIALSTATUSNAME: string;
}
export class timezoneModel {
  ZONEID: string;
  INTERNAL_NAME: string;
  TIMEZONE: string;
  LOCATION: string;
}
export class chatCommentModel {
  COMMENTID: string;
  TYPE: string;
  EXPIRED: string;
  PRIVACY: string;
  DOCUMENTID: string;
  COMMENTS: string;
  USERID: string;
  PRESENTATIONID: string;
  CONGRESSID: string;
  SUBPROJECTID: string;
  DOCTYPEID: string;
  TIMESTAMP: string;
  UNIXTIME: string;
  FIRSTNAME: string;
  LASTNAME: string;
  POLL: PollListingModel[];

  isText: boolean;
  isImage: boolean;
}
export class PollListingModel {
  COMMENTID: string;
  MCQ: string;
  POLLID: string;
  POLL_QUESTION: string;
  RESULT: PollResultListingModel[];
  OPTIONS: string[];
}
export class PollResultListingModel {
  STATS: number;
  PERCENTAGE: string;
  MSG: string;
  MEMBERS: PollAnswerMemberListModel[];
}
export class PollAnswerMemberListModel {
  USERID: string;
  NAME: string;
}
export class commentPostModel {
  congressid: string;
  comment: string;
  documentid: number;
  type: string;
  userid: number;
  filelist: any[];
}
export class pollRequestModel {
  poll_question: string;
  options: Array<PollOptionTest>;
  mcq: number;
  duration: string;
  privacy: boolean;
}
export class PollOptionTest {
  optionName: string;
}
export class sendMessageModel {
  sender: string;
  groupid: string;
  type: string;
  message: string;
  userid: number;
  subprojectid: number;
  filelist: any[];
}

export class directMsgSenderListModel {
  DMID: string;
  FIRSTNAME: string;
  GROUPID: string;
  GROUPNAME: string;
  ID: string;
  MESSAGE: string;
  SENDER: string;
  STATUS: string;
  TIME: string;
  TYPE: string;
}
export class detailScreenRequestModel {
  data: any;
  caller: string;
  image: string;
  relative: any;
}

export class ADVANCE_SEARCH {
  SEARCH_KEYWORD: string = null;
  START_DATE: any = null;
  END_DATE: Date = null;
  CATEGORY: any[] = null;
  COMPANY: any[] = null;
  CONGRESS: any[] = null;
  PRODUCT: any[] = null;
  INDICATION: any[] = null;
  CLINICAL_TRAILS: [] = null;
  COUNTRY: any[] = null;
  MOA: any[] = null;
  CLASS: any[] = null;

  TIMESTAMP: any;
  SORT: any;
}

export class CONFIRM_PASSWORD {
  OLD_PASSWORD: string = null;
  NEW_PASSWORD: String = null;
  CONFIRM_PASSWORD: String = null;
}

export class ACCOUNT_DATA {
  'ADD/REG': String;
  CAPTURE: String;
  CHAT: String;
  CLINICAL_TRIALS: String;
  CONGRESS: String;
  CONGRESS_ADMIN: String;
  COUNTRYID: String;
  DEFAULT: String;
  'DIRECT MESSAGE': String;
  EMAIL: String;
  EXPIRYDATE: String;
  EXPORT: String;
  GALLERY: String;
  KITS: String;
  LATEST_LOGIN: String;
  NAME: String;
  NEWS: String;
  NEWSLETTER: String;
  OPTIONALGROUPID: null;
  PASSWORD: String;
  PRODUCT: String;
  REPORTS: String;
  ROLE: string;
  SECURELVL: String;
  SUBPROJECTID: String;
  TIMELINES: String;
  TOTALVIEWS: string;
  TOTAL_LOGIN: string;
  UPCOMING_EVENTS: String;
  UPLOADS: string;
  USERID: String;
  USERSTATUS: String;
  USER_GROUPID: String;
  USER_GROUPNAME: String;
  VIEWCHAT: String;
  VISIBLE: String;
  WORKSHOP: String;
  LASTLOGINDATE: any;
  ADDEDDATE: any;
}
//stateid 1 - InActive
//2 - Active
//3 - Draft
//4 - Deleted

export class congressListData {
  ACRONYMS: String;
  CHECKIN_STATUS: String;
  CONGRESS_STATUS: String | number;
  CITY: String;
  CONGRESSID: String;
  CONGRESSNAME: String;
  COUNTRYNAME: String;
  ENDDATE: String;
  ENDMONTH: String;
  ENDYEAR: String;
  LOCATION: String;
  REPORTS: String;
  STARTDATE: String;
  STARTMONTH: String;
  STARTYEAR: String;
  TIMEZONE: String;
  UPLOADS: String;
}
export class congressListingData {
  BOOKMARKED: number;
  BRANDNAME: String;
  COMMENTCOUNT: String;
  CONGRESSID: String;
  DOCDATE: String;
  DOCTYPEID: String;
  DOCUMENTID: String;
  ENDDATE: String;
  ENDTIME: String;
  HOTTOPIC: String;
  IMAGECOUNT: String;
  INDICATIONNAME: String;
  INSERTSTAMP: String;
  LEADAUTHORNAME: String;
  LOCATIONID: String;
  LOCATIONNAME: String;
  NOTES: String;
  NOTESCOUNT: String;
  POLLCOUNT: String;
  SESSIONTYPEID: String;
  SESSIONTYPENAME: String;
  SPONSORNAME: String;
  STARTDATE: String;
  STARTTIME: String;
  SUBPROJECTID: String;
  TIMESTAMP: String;
  TITLE: String;
  USERID: String;
  VIDEOCOUNT: String;
}

export class congressListingSubprocess {
  AUTHORNAME: String;
  BOOKMARKED: number;
  BRANDID: String;
  BRANDNAME: String;
  CLASSNAME: String;
  COMMENTCOUNT: String;
  CONGRESSID: String;
  DOCDATE: String;
  DOCTYPEID: String;
  DOCUMENTID: String;
  ENDTIME: String;
  IMAGECOUNT: String;
  INDICATIONID: String;
  INDICATIONNAME: String;
  INGREDIENTNAME: String;
  LOCATIONNAME: String;
  MOANAME: String;
  NOTESCOUNT: String;
  POLLCOUNT: String;
  PRESENTATIONID: String;
  SESSIONTYPEID: String;
  SESSIONTYPENAME: String;
  SPONSORID: String;
  SPONSORNAME: String;
  STARTTIME: String;
  SUBSESSIONTITLE: String;
  TIMESTAMP: String;
  VIDEOCOUNT: String;
}
export class detailScreenFilter {
  tag: string;
  name: string;
  id: string;
}
export class accountAddModel {
  name: string;
  email: string;
  password: string;
  countryid: string;
  groupid: string;
  groupidOption: string;
  expiryDate: string;
  security: string;
  role: string;
  frenchiseid: string;
  defaultpage: string;
  otherFeature: any[] = commonClass.AccountOtherFeaturesList;
  CURRENT_STATUS: any;
  userid: string;
  visible: string;
  mobile: string;
}
export class DirectMessage {
  ID: String;
  GROUPID: String;
  DMID: String;
  GROUPNAME: String;
  MESSAGE: String;
  TYPE: String;
  STATUS: String;
  SENDER: String;
  FIRSTNAME: String;
  TIME: String;
  'UNREAD/DM': String;
}
export class notificationDM {
  DMID: string;
  GROUPID: string;
  body: string;
  congressid: string;
  'gcm.notification.priority': string;
  id: string;
  name: string;
  notiType: string;
  sender: string;
  silent: string;
  subprojectid: string;
  title: string;
  type: string;
  message: any;
}
export class notificationDocNew {
  doctypeid: string;
  congressid: string;
  body: string;
  'gcm.notification.priority': string;
  id: string;
  subprojectid: string;
  notiType: string;
  title: string;
  silent: string;
  type: string;
  message: any;
}
export class notificationDocComments {
  doctypeid: string;
  body: string;
  'gcm.notification.priority': string;
  id: string;
  pid: string;
  subprojectid: string;
  notiType: string;
  title: string;
  silent: string;
  type: string;
  message: any;
}
export class tooltipsMessages {
  public static dm: string = 'Direct Message';
  public static applyFilter: string = 'Apply filters to fine tune your results';
  public static inbox: string = 'Editors InBox waiting to be approved';
  public static ai: string = 'AI – Ask me Anything';
  public static timeline: string = 'Timeline View';
  public static list: string = 'List View';
  public static exportPpt: string = 'Export to PowerPoint';
  public static resReq: string = 'Research Request';
  public static notification: string = 'New Notifications';
  public static profile: string = 'View/Edit Profile';
  public static askMeText: string =
    'Ask me anything but first please select which documents you want me to analyze then press';
  public static liveChatName: string = ' Document(s) analyzed';
  public static goButton: string = 'Ask me anything !';
  public static moveDraft: string =
    'Caution: Remove documents from production for editor review';
  public static moveDelete: string = 'Caution: Delete selected documents';
  public static documentWaiting: string = 'Document waiting to be reviewed';
  public static add : string = 'Add'
}
